import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppLoginModule } from './../app-login/app-login.module';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentModule } from './../payment/payment.module';
import { RegistrationPaymenntComponent } from './registration-paymennt/registration-paymennt.component';


// export const registrationRouting: ModuleWithProviders = RouterModule.forChild([]);
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    AppLoginModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PaymentModule,
    // registrationRouting
  ],
  exports: [RegistrationPaymenntComponent],
  declarations: [RegistrationPaymenntComponent]
})
export class RegistrationModule { }




// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/registration/registration.module.ts